var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invert",
    transform: "translate(-624 -370)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67995",
    "data-name": "Group 67995",
    transform: "translate(2195.204 -5241.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67996",
    "data-name": "Group 67996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "exchange-vertical",
    d: "M-1556.32,5639.828v-24h-2.033v19.1l-7.413-7.406-1.437,1.423,9.867,9.875Zm-1.041-3.908h.047l-.022.024Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39348",
    "data-name": "Path 39348",
    d: "M-1538.686,5615.828v24h2.033v-19.1l7.413,7.407,1.438-1.424-9.867-9.875Z",
    transform: "translate(-14.887)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    transform: "translate(624 370)",
    fill: "none",
    stroke: "#8d7c9460",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.a568193f356eca44caf7ea0f12c3910e.svg";
export { ForwardRef as ReactComponent };